import React, { useEffect, useState } from 'react';
import { Heading } from '../../../../_lib/components/Heading/Heading';
import { murmurhash } from '../../../../lib/js/hash';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { CheckRadioForLists, RadioParam } from '../../../../_lib/Form2';
import { RequiredSymbol } from '../../../../_lib/Form2/partials/RequiredSymbol/RequiredSymbol';
import { AccessLevel } from '../types';
import { tryTranslate } from '../../../../lib/translation/utils';

type AccessLevelChoicesFormProps = {
  params: RadioParam<'accessLevel', AccessLevel>[];
  setSelectedAccessLevelParameters: (param: RadioParam<'accessLevel', AccessLevel> | undefined) => void;
};

export function AccessLevelChoicesForm({ params, setSelectedAccessLevelParameters }: AccessLevelChoicesFormProps) {
  const { t } = useSonTranslation('AccessLevel');

  const [selectedAccessLevel, setSelectedAccessLevel] = useState<string | undefined>();

  /** sort params alphabetically */
  const sortParams = (parameters: (RadioParam<'accessLevel', AccessLevel>)[]) => {
    return parameters.sort((a, b) =>
      // we could make tryTranslate return an empty string instead of null?
      tryTranslate(`AccessLevel:form.accessLevels.${a?.value}.title`, null, '') >
      tryTranslate(`AccessLevel:form.accessLevels.${b?.value}.title`, null, '')
        ? 1
        : -1,
    );
  };

  const selectAccessLevel = (param: RadioParam<'accessLevel', AccessLevel>) => {
    setSelectedAccessLevelParameters(param);
    setSelectedAccessLevel(param?.value);
  };

  // on mount we want to pre-select an existing access-level (editing)
  useEffect(() => {
    const checkedParam = params.find(param => param.checked);
    if (checkedParam) {
      selectAccessLevel(checkedParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Heading hierarchy={3} className="access-level__choices-form-heading font-bold-16-20">
        <>
          {t('steps.accessLevel.headline')}
          <RequiredSymbol />
        </>
      </Heading>
      <div className="access-level__choices-form-selection">
        {sortParams(params).map(param => (
          <CheckRadioForLists
            key={murmurhash(param?.value)}
            type="radio"
            modifier="create-page"
            label={t(`AccessLevel:form.accessLevels.${param.value}.title`)}
            description={t(`form.accessLevels.${param.value}.description`)}
            param={param}
            checked={selectedAccessLevel === param?.value}
            onChange={() => {
              selectAccessLevel(param);
            }}
          />
        ))}
      </div>
    </>
  );
}
